/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {KTSVG} from '../../../helpers'
import {useFormik} from 'formik'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {IAppsModel} from '../../../../types/apps/AppsModel'
import {IAppAmoCRMLine} from '../create-app/IAppModels'
import {IAmoCRMLineNew} from '../../../../types/apps/crm/amocrm/AmoCRMLineModel'
import {useIntl} from 'react-intl'
import {IAmoCRMUserModel} from '../../../../types/apps/crm/amocrm/AmoCRMUserModel'

const addLineAmoCRMSettingsEditShema = Yup.object().shape({
  line_newline: Yup.string().required('Line is required'),
  description_newline: Yup.string(),
  responsible_user_newline: Yup.string().required('Please, enter responsible user'),
  pipeline_newline: Yup.string(),
  smart_call_newline: Yup.boolean(),
  start_time_newline: Yup.string(),
  end_time_newline: Yup.string(),
  incoming_call_newline: Yup.string(),
  udpc_newline: Yup.boolean(),
  find_unsorted_newline: Yup.boolean(),
})

const AddLineAmoCRM: FC = () => {
  const intl = useIntl()
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  const [updateApp, {isLoading}] = appsAPI.useUpdateAppMutation()
  const [smartCallState, updateSmartCallState] = useState(false)
  const [allLines, setAllLines] = useState<IAppAmoCRMLine[]>(app?.settings.amocrm.lines!)
  const users: IAmoCRMUserModel[] = app?.settings.amocrm.users!
  const pipelines: any = app?.settings.amocrm.pipelines

  useEffect(() => {
    if (app && app.settings.amocrm.lines !== undefined) {
      setAllLines(app.settings.amocrm.lines)
    }
  }, [app])

  const checkDID = (did: string) => {
    const submit_btn = document.getElementById('submit_btn')
    let did_mark = false
    for (let i = 0; i < allLines.length; i++) {
      if (did !== '' && did === allLines[i].line) {
        did_mark = true
        break
      }
    }
    if (did_mark === false) {
      submit_btn?.removeAttribute('disabled')
      document.getElementById('error_message')?.classList.add('d-none')
    } else {
      submit_btn?.setAttribute('disabled', 'true')
      document.getElementById('error_message')?.classList.remove('d-none')
    }
  }

  const formikNewLine = useFormik<IAmoCRMLineNew>({
    initialValues: {
      line_newline: '',
      description_newline: '',
      pipeline_newline: pipelines.length !== 0 ? pipelines[0].name : 'Main',
      responsible_user_newline: users.length > 0 ? users[0].amocrm_user_id : 0,
      smart_call_newline: false,
      start_time_newline: '09:00',
      end_time_newline: '18:00',
      incoming_call_newline: 'Unsorted',
      udpc_newline: false,
      find_unsorted_newline: false,
    },
    validationSchema: addLineAmoCRMSettingsEditShema,
    onSubmit: (values) => {
      const newLine: IAppAmoCRMLine = {
        line: values.line_newline,
        description: values.description_newline,
        pipeline: values.pipeline_newline,
        responsible_user: values.responsible_user_newline,
        smart_call: values.smart_call_newline,
        start_time: values.start_time_newline,
        end_time: values.end_time_newline,
        incoming_call_mode: {
          none: values.incoming_call_newline === 'None' ? true : false,
          contact: values.incoming_call_newline === 'Contact' ? true : false,
          contact_lead: values.incoming_call_newline === 'ContactLead' ? true : false,
          unsorted: values.incoming_call_newline === 'Unsorted' ? true : false,
        },
      }

      const data = {
        id: appId,
        settings: {
          amocrm: {
            lines: [...allLines, newLine],
          },
        },
      }
      updateApp(data as IAppsModel)
        .unwrap()
        .then(() => {
          const close = document.getElementById('close-modal')
          const smartCallNewSwitch = document.getElementById('smartCallNewSwitch')
          const udpcNewSwitch = document.getElementById('udpcNewSwitch')
          const findUnsortedNewSwitch = document.getElementById('findUnsortedNewSwitch')

          if (smartCallNewSwitch?.getAttribute('value') === 'true') {
            smartCallNewSwitch?.click()
          }

          if (udpcNewSwitch?.getAttribute('value') === 'true') {
            udpcNewSwitch?.click()
          }

          if (findUnsortedNewSwitch?.getAttribute('value') === 'true') {
            findUnsortedNewSwitch?.click()
          }
          updateSmartCallState(false)
          formikNewLine.resetForm()
          close?.click()
        })
    },
  })

  return (
    <form onSubmit={formikNewLine.handleSubmit} noValidate className='form'>
      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <div className='modal-dialog modal-dialog-centered mw-700px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2>{intl.formatMessage({id: 'APPS.SETTINGS.LINES.NEWLINE.TITTLE'})}</h2>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
              </div>
            </div>
            <div className='modal-body'>
              <div className='flex-row-fluid py-5 px-15'>
                <div className='current' data-kt-stepper-element='content'>
                  <div className='col-12'>
                    <div className='mb-10'>
                      <div className='d-flex flex-stack'>
                        <label className='d-flex align-items-center col-5 self-align-center required'>
                          <span className='small text-uppercase fw-bolder text-gray-600'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.LINE'})}
                          </span>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-solid'
                          placeholder='DID'
                          onInput={(e: any) => {
                            checkDID(e.target.value)
                          }}
                          {...formikNewLine.getFieldProps('line_newline')}
                        />
                      </div>
                      <div className='d-flex justify-content-end'>
                        <div className='fv-plugins-message-container'>
                          <div id='error_message' className='fv-help-block text-danger d-none'>
                            This DID is already in used
                          </div>
                        </div>
                      </div>

                      <div className='d-flex justify-content-end'>
                        {formikNewLine.touched.line_newline && formikNewLine.errors.line_newline && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{formikNewLine.errors.line_newline}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='mb-10 d-flex flex-stack'>
                      <label className='d-flex align-items-center col-5 self-align-center'>
                        <span className='small text-uppercase fw-bolder text-gray-600'>
                          {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.DESCRIPTION'})}
                        </span>
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Description'
                        {...formikNewLine.getFieldProps('description_newline')}
                      />
                    </div>
                    <div className='mb-10'>
                      <div className='d-flex flex-stack'>
                        <div className='stepper-label align-items-center col-5 self-align-center'>
                          <h3 className='small text-uppercase fw-bolder text-gray-600 required'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.USER'})}
                          </h3>
                          <div className='text-muted fs-8'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.USER.DESCRIPTION'})}
                          </div>
                        </div>
                        {users.length !== 0 ? (
                          <select
                            className='form-select form-select-solid'
                            {...formikNewLine.getFieldProps('responsible_user_newline')}
                          >
                            {users?.map((user: IAmoCRMUserModel) => (
                              <option value={user.amocrm_user_id} key={user.id}>
                                {user.amocrm_user_id} - {user.fullname}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            className='form-control form-control-solid'
                            placeholder='user ID'
                            {...formikNewLine.getFieldProps('responsible_user_newline')}
                          />
                        )}
                      </div>
                      <div className='d-flex justify-content-end'>
                        {formikNewLine.touched.responsible_user_newline &&
                          formikNewLine.errors.responsible_user_newline && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block text-danger'>
                                {formikNewLine.errors.responsible_user_newline}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className='mb-10'>
                      <div className='d-flex flex-stack'>
                        <div className='stepper-label align-items-center col-5 self-align-center'>
                          <h3 className='small text-uppercase fw-bolder text-gray-600 required'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.PIPELINE'})}
                          </h3>
                        </div>
                        {pipelines.length !== 0 ? (
                          <select
                            className='form-select form-select-solid'
                            {...formikNewLine.getFieldProps('pipeline_newline')}
                          >
                            {pipelines?.map((pipeline: any) => (
                              <option value={pipeline.name} key={pipeline.name}>
                                {pipeline.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            className='form-control form-control-solid'
                            placeholder='pipeline'
                            disabled
                            {...formikNewLine.getFieldProps('pipeline_newline')}
                          />
                        )}
                      </div>
                      <div className='d-flex justify-content-end'>
                        {formikNewLine.touched.pipeline_newline && formikNewLine.errors.pipeline_newline && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block text-danger'>{formikNewLine.errors.pipeline_newline}</div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='mb-10 d-flex'>
                      <div className='d-flex me-15 col-12'>
                        <label className='d-flex flex-column col-5'>
                          <span className='small text-uppercase fw-bolder text-gray-600'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.SMARTCALL'})}
                          </span>
                          <span className='small text-gray-500'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.LINES.HEADER.SMARTCALLBYTIME'})}
                          </span>
                        </label>
                        <div className='d-flex align-items-center'>
                          <div className='form-check form-switch form-check-custom form-check-solid '>
                            <input
                              className='form-check-input h-20px w-30px align-self-center'
                              type='checkbox'
                              onClick={(e: any) => {
                                updateSmartCallState(e.target.checked)
                              }}
                              id='smartCallNewSwitch'
                              {...formikNewLine.getFieldProps('smart_call_newline')}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='mb-10 d-flex flex-stack'>
                      <label className='d-flex col-5'></label>
                      <div className='d-flex align-items-center col-7'>
                        <input
                          type='text'
                          className='form-control form-control-solid me-5'
                          placeholder='09:00'
                          disabled={!smartCallState}
                          {...formikNewLine.getFieldProps('start_time_newline')}
                        />
                        -
                        <input
                          type='text'
                          className='form-control form-control-solid ms-5'
                          placeholder='18:00'
                          disabled={!smartCallState}
                          {...formikNewLine.getFieldProps('end_time_newline')}
                        />
                      </div>
                    </div>
                    <div className='mb-10'>
                      <div className='d-flex flex-stack'>
                        <div className='stepper-label align-items-center col-5 self-align-center'>
                          <h3 className='small text-uppercase fw-bolder text-gray-600 required'>
                            {intl.formatMessage({id: 'APPS.SETTINGS.AMOCRM.INCOMING'})}
                          </h3>
                        </div>
                        <select
                          className='form-control form-control-solid'
                          {...formikNewLine.getFieldProps('incoming_call_newline')}
                        >
                          <option value='None'>None</option>
                          <option value='Unsorted'>Unsorted</option>
                          <option value='Contact'>Contact</option>
                          <option value='ContactLead'>Contact + Lead</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal-footer'>
              <div className='card-footer d-flex justify-content-end py-2 px-1' style={{border: 'none'}}>
                <button type='submit' id='submit_btn' className='btn btn-sm btn-primary me-3' disabled={isLoading}>
                  {!isLoading && intl.formatMessage({id: 'BUTTON.SAVE'})}
                  {isLoading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {intl.formatMessage({id: 'WAIT'})}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <button
                  type='button'
                  className='btn btn-sm btn-light-primary align-self-center'
                  id='close-modal'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  {intl.formatMessage({id: 'BUTTON.CANCEL'})}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

export {AddLineAmoCRM}
